import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SavedToXrefComponent } from './saved-to-xref.component';
import { TranslateModule } from '@xref/ngx';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FooterMarketingModule } from 'src/app/components/footer-marketing/footer-marketing.module';
import { BlogPostsModule } from 'src/app/components/blog-posts/blog-posts.module';
import { defaultPageScrollConfig, NGXPS_CONFIG } from 'ngx-page-scroll-core';

@NgModule({
  declarations: [SavedToXrefComponent],
  exports: [SavedToXrefComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FontAwesomeModule,
    FooterMarketingModule,
    BlogPostsModule
  ],
  providers: [
    {provide: NGXPS_CONFIG, useValue: defaultPageScrollConfig}
  ]
})
export class SavedToXrefModule { }
